import React from 'react';
import Modal from 'components/UI/Modal';
import { connect } from 'react-redux';

import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
// import getTimetable from 'controllers/school/getTimetable'
import {fetchSchedule} from 'containers/pages/Schedule/ducks'
import moment from 'moment'


const mapStateToProps = (state) => ({
  user: state.user,
})

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      dispatch,
    } = this.props;

    const schoolId = localStorage.getItem('schoolId')
    let start_date = moment(new Date()).startOf('month').format('YYYY-MM-DD');
    let end_date = moment(new Date()).endOf('month').format('YYYY-MM-DD');

		return (
			<Modal
				className='attendance-scan-modal'
				hasHeader={true}

				headerTitle={__("Smart Check In", "attendanceScan")}
				headerIcon="fa icon-qrcode"
        fixedWidth={600}
        contentHeight={550}
        onCloseModalClick={() => {
          dispatch(fetchSchedule(schoolId, {start_date, end_date}))
          dismiss()
        }}

        footerType="grey"
        isShowingModal={show} >
        <ModalContent />
			</Modal>
    );
  }
}

export default connect(mapStateToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/AttendanceScan/ModalBody.js